import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const apply = (items, fabrica, update) => {
    const params = [];

    const data = items
        .filter((item) => item.cdFabrica !== fabrica && item.listaTecnica.some((lt) => lt.CD_FABRICA === fabrica))
        .map((item) => {
            const listaTecnica = item.listaTecnica.find((lt) => lt.CD_FABRICA === fabrica);

            item.cdFabrica = fabrica;
            item.no = listaTecnica.no;
            item.cdFabricaPrep = listaTecnica.cdFabricaPrep;
            item.tempo = listaTecnica.tempo;
            item.tempoPreparacao = listaTecnica.tempoPreparacao;

            params.push({
                material: item.material,
                data: item.data,
                estacao: item.estacao,
                colecao: item.colecao,
                cor: item.cor,
            });

            return {
                material: item.material,
                estacao: item.estacao,
                colecao: item.colecao,
                data: item.data,
                fabrica: item.cdFabrica,
                fabricaPrep: item.cdFabricaPrep,
                no: item.no,
                tempo: item.tempo,
                tempoPreparacao: item.tempoPreparacao,
                pv: item.pv,
            };
        });

    if (data.length === 0) return;

    update(data, params, fabrica);
};

const buildArrayFabricas = (items) => {
    const fabricas = [];
    items.forEach((item) => {
        item.listaTecnica.reduce((arr, listaTecnica) => {
            if (arr.includes(listaTecnica.CD_FABRICA)) return arr;

            arr.push(listaTecnica.CD_FABRICA);
            return arr;
        }, fabricas);
    });

    return fabricas;
};

const AplicarFabrica = ({ items, isOpen, onClose, update }) => {
    return (
        <Modal isOpen={isOpen} toggle={onClose}>
            <ModalHeader className='modal-title' style={{ position: 'relative', height: 50 }}>
                <span style={{ position: 'absolute', left: '41%' }}>Fábricas</span>
            </ModalHeader>
            <ModalBody>
                <div style={{ cursor: 'pointer' }}>
                    {buildArrayFabricas(items).map((fabrica) => (
                        <span
                            key={fabrica}
                            onClick={(_) => apply(items, fabrica, update)}
                            className='list-group-item list-group-item-action'
                        >
                            {fabrica}
                        </span>
                    ))}
                </div>
            </ModalBody>
        </Modal>
    );
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const mapStateToProps = (store) => ({
    fabricas: store.filterState.filtros.optionsFabrica,
});

export default connect(mapStateToProps, mapDispatchToProps)(AplicarFabrica);
